<template>
  <section class="features-section section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">开放灵活的生成式 AI 应用开发框架</h2>
        <p class="section-description">
          涵盖了构建生成式 AI 原生应用所需的核心技术栈，开发者可以聚焦于创造应用的核心价值。
        </p>
      </div>
      
      <div class="features-grid">
        <div class="feature-card neumorphic-card" v-for="(feature, index) in features" :key="index">
          <div class="feature-icon">
            <i :class="feature.icon"></i>
          </div>
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
          <a href="#" class="feature-link">了解更多 <i class="fas fa-arrow-right"></i></a>
        </div>
      </div>
    </div>
    <div class="section-background">
      <div class="gradient-circle circle-1"></div>
      <div class="gradient-circle circle-2"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FeaturesSection',
  data() {
    return {
      features: [
        {
          icon: 'fas fa-brain',
          title: 'RAG Pipeline',
          description: '安全构建私有数据与大型语言模型之间的数据通道，并提供高可靠的索引和检索工具。'
        },
        {
          icon: 'fas fa-code',
          title: 'Prompt IDE',
          description: '为提示词工程师精心设计，友好易用的提示词开发工具，支持无缝切换多种大型语言模型。'
        },
        {
          icon: 'fas fa-cogs',
          title: 'Enterprise LLMOps',
          description: '开发者可以观测推理过程、记录日志、标注数据、训练并微调模型；使应用效果脱离黑盒，持续迭代优化。'
        },
        {
          icon: 'fas fa-server',
          title: 'BaaS Solution',
          description: '基于后端及服务理念的 API 设计，大幅简化生成式 AI 应用研发流程。'
        },
        {
          icon: 'fas fa-robot',
          title: 'LLM Agent',
          description: '定制化 Agent，自主调用系列工具完成复杂任务。'
        },
        {
          icon: 'fas fa-project-diagram',
          title: 'Workflow',
          description: '编排 AI 工作流，使其输出更稳定可控。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.features-section {
  position: relative;
  background-color: var(--bg-darker);
  overflow: hidden;
}

.container {
  position: relative;
  z-index: 2;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
}

.feature-card {
  background-color: var(--bg-card);
  border-radius: var(--border-radius-lg);
  padding: 2.5rem 2rem;
  transition: var(--transition);
  border: var(--border-light);
  position: relative;
  overflow: hidden;
}

.feature-card:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-lg);
}

.feature-card:hover .feature-icon {
  background: var(--gradient-primary);
  color: white;
  box-shadow: 0 10px 20px rgba(123, 104, 238, 0.3);
}

.feature-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: var(--border-radius-md);
  background: linear-gradient(135deg, rgba(123, 104, 238, 0.1) 0%, rgba(147, 112, 219, 0.1) 100%);
  margin-bottom: 1.5rem;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.feature-icon i {
  font-size: 2rem;
  color: var(--primary-color);
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

.feature-card:hover .feature-icon i {
  color: white;
}

.feature-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--text-primary);
}

.feature-description {
  color: var(--text-secondary);
  line-height: 1.6;
  font-size: 1rem;
  margin-bottom: 1.5rem;
}

.feature-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--primary-color);
  transition: var(--transition);
}

.feature-link:hover {
  gap: 0.8rem;
}

.section-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.gradient-circle {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.2;
}

.circle-1 {
  width: 600px;
  height: 600px;
  background: linear-gradient(135deg, rgba(123, 104, 238, 0.2) 0%, rgba(147, 112, 219, 0.2) 100%);
  top: -300px;
  right: -200px;
}

.circle-2 {
  width: 500px;
  height: 500px;
  background: linear-gradient(135deg, rgba(147, 112, 219, 0.15) 0%, rgba(177, 156, 217, 0.15) 100%);
  bottom: -250px;
  left: -150px;
}

@media screen and (max-width: 1023px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 767px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
  
  .feature-card {
    padding: 2rem 1.5rem;
  }
  
  .feature-icon {
    width: 60px;
    height: 60px;
  }
  
  .feature-icon i {
    font-size: 1.6rem;
  }
  
  .feature-title {
    font-size: 1.3rem;
  }
}
</style> 